import Datatable from "./DatatableGroup";

export default Datatable;
